export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_adultbirthday-b59768e41ea32f9039261fc80531bffa.jpg";